const QAURL = 'https://service.edencaremedical.com/dev/api/v1/';
const ProdURL = 'https://service.edencaremedical.com/prod/api/v1/';
const UATURL = 'https://service.edencaremedical.com/dev/api/v1/';
const STAGINGURL = 'https://service.edencaremedical.com/stage/api/v1/';

export const baseURL = process.env.REACT_APP_VERCEL_ENV === 'production' ? ProdURL : (process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === 'uat' ? UATURL : (process.env.REACT_APP_VERCEL_GIT_COMMIT_REF === 'staging' ? STAGINGURL : QAURL));